module.exports = __webpack_public_path__ + "img/1302887191.00dabd07.jpg";